import { render, staticRenderFns } from "./EventoDetalhe.vue?vue&type=template&id=298f6164&"
import script from "./EventoDetalhe.vue?vue&type=script&lang=js&"
export * from "./EventoDetalhe.vue?vue&type=script&lang=js&"
import style0 from "./EventoDetalhe.vue?vue&type=style&index=0&id=298f6164&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports